import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '@/pages/Home';
import CGU from '@/pages/CGU';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import ComingSoon from '@/pages/ComingSoon';
import AndroidDownload from '@/pages/AndroidDownload';
import IOSInstall from '@/pages/IOSInstall';
import ManageSubscription from '@/pages/ManageSubscription';
import BallTrapCampagne from '@/pages/BallTrapCampagne';
import BallTrapCampagneSoumettre from '@/pages/BallTrapCampagneSoumettre';
import BallTrapCampagneManage from '@/pages/BallTrapCampagneManage';
import AdminCountryEvents from '@/pages/AdminCountryEvents';
import AdminCountryEventNew from '@/pages/AdminCountryEventNew';
import AdminUsers from '@/pages/AdminUsers';
import AdminDeviceRecovery from '@/pages/AdminDeviceRecovery';
import Clayo from '@/pages/Clayo';
import Support from '@/pages/Support';
import Marketing from '@/pages/Marketing';
import MonEspace from '@/pages/MonEspace';
import MonEspaceEvent from '@/pages/MonEspaceEvent';
import Welcome from '@/pages/Welcome';
import { Login, Register, ForgotPassword, ResetPassword } from '@/pages/AuthPages';
import { AuthProvider } from '@/contexts/AuthContext';

function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-[100] bg-[#0D0D0D] flex items-center justify-center">
      <div className="text-center">
        <div className="loading-logo inline-flex items-center gap-2 mb-4">
          <img
            src="/assets/img/logo-claypulse.jpg"
            alt="ClayPulse"
            className="w-16 h-16 rounded-2xl object-cover"
          />
        </div>
        <p className="text-[#A0A0A0] text-sm font-['Manrope'] mt-4">Chargement...</p>
      </div>
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  // /app/* routes are served as static files from /public/app/ (the Expo
  // PWA static export). In production, some static hosts apply a SPA
  // fallback that returns the React landing's index.html for /app/*
  // instead of the PWA's own index.html — which makes React render `null`
  // here and the user sees a black screen.
  //
  // Fix: when we detect we're on /app/* and the PWA's bootstrap script is
  // NOT in the document, force a hard navigation to the explicit PWA
  // index file. We can't use `document.open/write/close` because that
  // breaks Expo's `Font.loadAsync` flow (icons would disappear). A clean
  // page load via `location.replace` lets all fonts and the service
  // worker register normally; the service worker then intercepts future
  // /app/* requests so deep links work on subsequent visits.
  if (window.location.pathname.startsWith('/app')) {
    if (!document.querySelector('script[src="/app/claypulse-init.js"]')) {
      if (!window.__cpPwaBootstrapping) {
        window.__cpPwaBootstrapping = true;
        // Preserve the original deep path in sessionStorage so the
        // claypulse-init.js bootstrap can route there once the bundle is
        // up. The SW will then cache the PWA index for future direct hits.
        try {
          sessionStorage.setItem(
            'cp_intended_path',
            window.location.pathname + window.location.search + window.location.hash
          );
        } catch (_) {}
        window.location.replace('/app/index.html');
      }
    }
    return null;
  }

  return (
    <div className="App">
      {loading && <LoadingScreen />}
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/android" element={<AndroidDownload />} />
            <Route path="/ios" element={<IOSInstall />} />
            <Route path="/manage-subscription" element={<ManageSubscription />} />
            <Route path="/abonnement" element={<ManageSubscription />} />
            <Route path="/ball-trap-campagne" element={<BallTrapCampagne />} />
            <Route path="/carte" element={<BallTrapCampagne />} />
            <Route path="/ball-trap-campagne/soumettre" element={<BallTrapCampagneSoumettre />} />
            <Route path="/ball-trap-campagne/manage/:token" element={<BallTrapCampagneManage />} />
            <Route path="/admin/country-events" element={<AdminCountryEvents />} />
            <Route path="/admin/country-events/new" element={<AdminCountryEventNew />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/device-recovery" element={<AdminDeviceRecovery />} />
            <Route path="/clayo" element={<Clayo />} />
            <Route path="/support" element={<Support />} />
            <Route path="/assistance" element={<Support />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/app" element={<Marketing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/mon-espace" element={<MonEspace />} />
            <Route path="/mon-espace/event/:id" element={<MonEspaceEvent />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
